module.exports = __webpack_public_path__ + "static/media/circle.7f60a717.svg";